import React from 'react';
import { Col, Row } from 'react-bootstrap'
import { Route } from 'react-router-dom'



const ArticlesCard = ( {details} ) => {
    const requireImage = chemin => {
        if("" !== chemin){
            return chemin
        }else{
            return require(`../img/default.png`)
        }
    }
    return (
        <div>
            <Row className="justify-content-md-center">      
            {
                Object
                .entries(details)
                .map(key => 
                    <Col key={key} lg={4} md={6} sm={6} xs={12} className="nopadding">

                    <div className="articleList" key={key}>
                        <img 
                        src={requireImage(key[1][1].base64)}
                        alt={key[1][1].nom}
                        width="50%"
                        />
                    <div className="nom-article-list">
                        <h3>{key[1][1].nom}</h3>
                    </div>
                    <Route render={({ history }) => (
                        <button
                        type='button'
                        className="btn btn-primary btn-blue-light"
                        onClick={() => { history.push({
                            pathname : `/articles/` + key[1][1].nom,
                            state: { recette: key[1][0] }
                        })
                        }}
                        >
                        EN LIRE PLUS
                        </button>
                    )} />
                    </div>

                    </Col>
                )
            }
            </Row>

        </div>
    );
};

export default ArticlesCard;